/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Characternamemars2Inputs */



/**
* | output |
* | --- |
* | "Mars" |
*
* @param {Characternamemars2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const characternamemars2 = /** @type {((inputs?: Characternamemars2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Characternamemars2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Mars")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mars")
	return /** @type {LocalizedString} */ ("Марс")
});
export { characternamemars2 as "characterNameMars" }